import { CdkTableModule } from '@angular/cdk/table';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { EventBuyerComponentsModule } from '@tix/event-buyer/components';
import { TixEventBuyerStateModule } from '@tix/event-buyer/state';
import { FullCalendarModule } from '@fullcalendar/angular';
import {
  HeroArrowRightSolid,
  HeroClockIconSolid,
  HeroLockIcon,
  HeroPlusSolid,
  HeroTrashIcon,
  HeroExclamationCircle,
  TixButtonModule,
  TixCardModule,
  TixCheckboxModule,
  TixEmptyStateModule,
  TixIconModule,
  TixIconRegistry,
  TixInputModule
} from '@tix/shared/ui/components';
import { TixFeesModule } from '@tix/shared/utils';
import { TixPipesModule } from '@tix/shared/ui/pipes';
import { AngularDraggableModule } from 'angular2-draggable';
import { TextMaskModule } from 'angular2-text-mask';
import { NgxPaginationModule } from 'ngx-pagination';
import { CreditCardDirective } from '../../../../shared/ui/directives/credit-card.directive';
import { CreditCardDateDirective } from '../../../../shared/ui/directives/credit-date.directive';
import { EventBuyerRoutingModule } from './event-buyer-routing.module';
import { TixEventBuyerPage } from './event-buyer/event-buyer.component';
import { TixOrderSummaryPage } from './order-summary/order-summary.component';
import { TixPaymentSuccessPage } from './payment-success/payment-success.component';
import { VenuePortalComponent } from './venue-portal/venue-portal.component';
import { VenueSlugRedirectPageComponent } from './venue-slug-redirect-page/venue-slug-redirect-page.component';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { ProductsSummaryComponent } from './products-summary/products-summary.component';
import { TixEventCalendarViewFrontComponent } from './event-calendar-view-front/event-calendar-view-front.component';
import { DomSanitizer } from '@angular/platform-browser';
import { EventFrontCalendarCardComponent } from './event-front-calendar-card/event-front-calendar-card.component';
import { FrontofficeWrapperComponent } from './frontoffice-wrapper/frontoffice-wrapper.component';
import { OrderPaymentService } from '@tix/event-buyer/services';

@NgModule({
  providers: [CurrencyPipe, OrderPaymentService],
  imports: [
    EventBuyerRoutingModule,
    CommonModule,
    FullCalendarModule,
    CdkTableModule,
    TixButtonModule,
    TixCardModule,
    TixIconModule,
    MatFormFieldModule,
    MatInputModule,
    TixInputModule,
    FormsModule,
    ReactiveFormsModule,
    EventBuyerComponentsModule,
    TixEventBuyerStateModule,
    NgxPaginationModule,
    TixCheckboxModule,
    TixEmptyStateModule,
    TextMaskModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    MatTooltipModule,
    TixFeesModule,
    EventBuyerRoutingModule,
    MatAutocompleteModule,
    MatSelectModule,
    MatProgressBarModule,
    AngularDraggableModule,
    MatIconModule,
    MatMenuModule,
    TixPipesModule
  ],
  declarations: [
    TixEventBuyerPage,
    TixOrderSummaryPage,
    CreditCardDateDirective,
    CreditCardDirective,
    TixPaymentSuccessPage,
    VenuePortalComponent,
    VenueSlugRedirectPageComponent,
    ProductsSummaryComponent,
    TixEventCalendarViewFrontComponent,
    EventFrontCalendarCardComponent,
    FrontofficeWrapperComponent
  ]
})
export class TixEventBuyerPagesModule {
  constructor(
    private iconRegistry: TixIconRegistry,
    private sanitizer: DomSanitizer
  ) {
    iconRegistry.addSvgIconConfigs([
      HeroArrowRightSolid,
      HeroPlusSolid,
      HeroTrashIcon,
      HeroClockIconSolid,
      HeroLockIcon,
      HeroExclamationCircle
    ]);
    iconRegistry.addSvgIcon(
      'google-wallet-icon',
      sanitizer.bypassSecurityTrustResourceUrl(
        'assets/images/brands/google_wallet.svg'
      )
    );
    iconRegistry.addSvgIcon(
      'apple-wallet-icon',
      sanitizer.bypassSecurityTrustResourceUrl(
        'assets/images/brands/Apple_Wallet.svg'
      )
    );

    iconRegistry.addSvgIcon(
      'no-image-event',
      sanitizer.bypassSecurityTrustResourceUrl(
        'assets/images/no-image-event.png'
      )
    );
  }
}
